<div class="col-12" *ngIf="outCustody">
  <div class="form-check form-check-inline" style="padding-top: 40px">
    <input
      data-cy="outCustody"
      class="form-check-input"
      id="outCustody"
      name="outCustody"
      [disabled]="true"
      [checked]="true"
      type="checkbox"
    />
  </div>
  <label for="outCustody">Fora da Custódia</label>
</div>
